import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "container-full-5 collectivites-onboarding" }
const _hoisted_2 = {
  key: 0,
  class: "flex-center py-10"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "alert alert-danger mb-4"
}
const _hoisted_5 = {
  key: 1,
  class: "alert alert-success mb-4"
}
const _hoisted_6 = { class: "wizard-stepper mb-6" }
const _hoisted_7 = { class: "stepper-container" }
const _hoisted_8 = { class: "stepper-circle" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "stepper-circle" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "stepper-circle" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "widget px-8 py-7 s20" }
const _hoisted_18 = { class: "widget px-8 py-7 s20" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "flex justify-content-between mt-6" }
const _hoisted_21 = { class: "widget px-8 py-7 s20" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "tag-state lg rounded-50 flex align-items-center gap-4 px-4 py-4 mb-6" }
const _hoisted_24 = ["src"]
const _hoisted_25 = {
  key: 1,
  class: "rounded-100 overflow-hidden size-2xl bg-grey-200 flex-center"
}
const _hoisted_26 = { class: "px-3" }
const _hoisted_27 = { class: "my-1" }
const _hoisted_28 = { class: "text-sm" }
const _hoisted_29 = { class: "form-field-floating reactive my-5" }
const _hoisted_30 = { class: "form-switch lg" }
const _hoisted_31 = { class: "switch" }
const _hoisted_32 = { class: "flex justify-content-between mt-6" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = ["disabled"]
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }

import { onMounted, reactive, ref } from 'vue'
import OnboardingPersonalInfosForm from '@/components/collectivites/onboarding/OnboardingPersonalInfosForm.vue'
import OnboardingIdentityDocumentsForm from '@/components/collectivites/onboarding/OnboardingIdentityDocumentsForm.vue'
import OnboardingPayslipDocumentsForm from '@/components/collectivites/onboarding/OnboardingPayslipDocumentsForm.vue'
import onboardingService from '@/services/onboardingService'
import membersService from '@/services/membersService'
import { showAlert } from '@/utils/swal'
import authService from '@/services/authService'
import { TokenStorage } from '@/services/apiConfig'

interface Collectivite {
  id: number
  nom: string
}

interface PersonalInfosPayload {
  nom: string | null
  prenom: string | null
  date_naissance: string | null
  age: number
  date_engagement: string | null
  anciennete: number
  collectivite_id: number | null
  salaire: string
  quotite_cessible_pourcent: string
  quotite_cessible_montant: string
  telephone: string | null
  email: string | null
}

interface UploadedFile {
  file: File
  name: string
  preview?: string | ArrayBuffer | null
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FrontofficeCollectivites',
  setup(__props) {

const currentStep = ref(1)

const pageLoading = ref(true)
const submitLoading = ref(false)
const errorMessage = ref('')
const successMessage = ref('')
const defaultCollectiviteId = ref<number | null>(null)
const sendKycEmail = ref(true)

const formParams = reactive({
  collectivites: [] as Collectivite[],
  types_piece_identites: {} as Record<string, string>
})

const formDatas = reactive<{
  user: PersonalInfosPayload | null
  photo: UploadedFile | null
  type_piece_identite: string | null
  numero_piece_identite: string | null
  piece_recto: UploadedFile | null
  piece_verso: UploadedFile | null
  bulletin1: UploadedFile | null
  bulletin2: UploadedFile | null
  bulletin3: UploadedFile | null
}>({
  user: null,
  photo: null,
  type_piece_identite: null,
  numero_piece_identite: null,
  piece_recto: null,
  piece_verso: null,
  bulletin1: null,
  bulletin2: null,
  bulletin3: null
})

onMounted(async () => {
  await loadCollectivite()
  await loadFormDatas()
})

async function loadCollectivite() {
  try {
    // Récupérer la collectivité du membre connecté
    let currentUser = authService.getCurrentUser()
    
    // Si les données utilisateur ne contiennent pas la collectivité, récupérer le profil complet
    if (currentUser && !currentUser.collectivite_id && !currentUser.collectivite?.id && !(currentUser as any).collectiviteId) {
      const profileResponse = await authService.getProfile()
      if (profileResponse.status === 0 && profileResponse.data) {
        currentUser = profileResponse.data
        // Mettre à jour les données utilisateur dans le stockage
        TokenStorage.setUser(currentUser)
      }
    }
    
    if (currentUser) {
      // L'API peut retourner collectiviteId (camelCase) ou collectivite_id (snake_case)
      const collectiviteId = currentUser.collectivite_id || (currentUser as any).collectiviteId || currentUser.collectivite?.id
      
      if (collectiviteId) {
        defaultCollectiviteId.value = collectiviteId
      }
    }
  } catch (error: any) {
    console.error('Erreur lors du chargement de la collectivité:', error)
  }
}

async function loadFormDatas() {
  pageLoading.value = true
  errorMessage.value = ''
  try {
    const response = await onboardingService.getFormDatas()
    formParams.collectivites = response.collectivites || []
    formParams.types_piece_identites = response.types_piece_identites || {}
  } catch (error: any) {
    errorMessage.value = error.message || 'Impossible de charger les données du formulaire.'
  } finally {
    pageLoading.value = false
  }
}

function goToStep(step: number) {
  // Validation avant de changer d'étape
  if (step === 2 && !formDatas.user) {
    errorMessage.value = 'Veuillez d\'abord compléter les informations personnelles.'
    return
  }
  if (step === 3 && (!formDatas.user || !formDatas.photo)) {
    errorMessage.value = 'Veuillez d\'abord compléter les pièces d\'identité.'
    return
  }
  currentStep.value = step
  errorMessage.value = ''
  successMessage.value = ''
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

function onAccountCreated(payload: PersonalInfosPayload) {
  formDatas.user = payload
  successMessage.value = 'Informations personnelles enregistrées avec succès.'
  goToStep(2)
}

function onIdentityDocumentsSaved(identityDocs: any) {
  formDatas.photo = identityDocs.photo
  formDatas.type_piece_identite = identityDocs.type_piece_identite
  formDatas.numero_piece_identite = identityDocs.numero_piece_identite
  formDatas.piece_recto = identityDocs.piece_recto
  formDatas.piece_verso = identityDocs.piece_verso
  successMessage.value = 'Pièces d\'identité validées avec succès.'
  goToStep(3)
}

function getCollectiviteName(collectiviteId: number | null): string {
  if (!collectiviteId) return ''
  const collectivite = formParams.collectivites.find(c => c.id === collectiviteId)
  return collectivite?.nom || ''
}

function onPayslipDocumentsSaved(payslipDocs: any) {
  formDatas.bulletin1 = payslipDocs.bulletin1
  formDatas.bulletin2 = payslipDocs.bulletin2
  formDatas.bulletin3 = payslipDocs.bulletin3
  // Ne pas soumettre automatiquement, l'utilisateur doit cliquer sur "Soumettre l'onboarding"
  // successMessage.value = 'Bulletins de salaire validés avec succès.'
}

function validateBeforeSubmit() {
  if (!formDatas.user) {
    errorMessage.value = 'Veuillez créer le compte avant de poursuivre.'
    return false
  }
  const requiredFiles = [
    { field: formDatas.photo, label: 'Photo de profil' },
    { field: formDatas.piece_recto, label: 'Pièce recto' },
    { field: formDatas.piece_verso, label: 'Pièce verso' },
    { field: formDatas.bulletin1, label: 'Bulletin 1' },
    { field: formDatas.bulletin2, label: 'Bulletin 2' },
    { field: formDatas.bulletin3, label: 'Bulletin 3' }
  ]
  const missing = requiredFiles.find(item => !item.field)
  if (missing) {
    errorMessage.value = `Le fichier "${missing.label}" est requis.`
    return false
  }
  return true
}

function resetFlow() {
  formDatas.user = null
  formDatas.photo = null
  formDatas.type_piece_identite = null
  formDatas.numero_piece_identite = null
  formDatas.piece_recto = null
  formDatas.piece_verso = null
  formDatas.bulletin1 = null
  formDatas.bulletin2 = null
  formDatas.bulletin3 = null
  currentStep.value = 1
  errorMessage.value = ''
  successMessage.value = ''
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

async function doSaveKYCDocuments() {
  if (!validateBeforeSubmit() || !formDatas.user) {
    if (!formDatas.user) {
      errorMessage.value = 'Veuillez compléter les informations personnelles.'
      await showAlert.warning('Veuillez compléter toutes les étapes avant de soumettre.')
    } else {
      await showAlert.warning('Veuillez compléter tous les champs obligatoires avant de soumettre.')
    }
    return
  }

  submitLoading.value = true
  errorMessage.value = ''
  successMessage.value = ''

  try {
    const formToUpload = new FormData()
    formToUpload.append('nom', formDatas.user.nom || '')
    formToUpload.append('prenom', formDatas.user.prenom || '')
    formToUpload.append('date_naissance', formDatas.user.date_naissance || '')
    formToUpload.append('age', String(formDatas.user.age || ''))
    formToUpload.append('date_engagement', formDatas.user.date_engagement || '')
    formToUpload.append('anciennete', String(formDatas.user.anciennete || ''))
    formToUpload.append('collectivite_id', String(formDatas.user.collectivite_id || ''))
    formToUpload.append('salaire', formDatas.user.salaire || '')
    formToUpload.append('quotite_cessible_pourcent', formDatas.user.quotite_cessible_pourcent || '')
    formToUpload.append('quotite_cessible_montant', formDatas.user.quotite_cessible_montant || '')
    formToUpload.append('telephone', formDatas.user.telephone || '')
    formToUpload.append('email', formDatas.user.email || '')

    formToUpload.append('photo', formDatas.photo!.file)
    formToUpload.append('type_piece_identite', formDatas.type_piece_identite || '')
    formToUpload.append('numero_piece_identite', formDatas.numero_piece_identite || '')
    formToUpload.append('piece_recto', formDatas.piece_recto!.file)
    formToUpload.append('piece_verso', formDatas.piece_verso!.file)
    formToUpload.append('bulletin1', formDatas.bulletin1!.file)
    formToUpload.append('bulletin2', formDatas.bulletin2!.file)
    formToUpload.append('bulletin3', formDatas.bulletin3!.file)

    const response = await onboardingService.createAccount(formToUpload)
    
    // Récupérer l'ID de l'utilisateur créé depuis la réponse
    // La réponse peut avoir différentes structures selon l'API
    const responseData = (response as any).data || response
    const userId = responseData?.user_id || responseData?.id || (response as any).user_id || (response as any).id
    
    // Si l'option d'envoi d'email est activée et qu'on a un ID utilisateur, envoyer l'email de confirmation
    if (sendKycEmail.value && userId) {
      try {
        await membersService.sendConfirmationEmail([userId])
        await showAlert.success(
          'Compte créé avec succès ! L\'email de confirmation a été envoyé.',
          'Inscription réussie'
        )
      } catch (emailError: any) {
        // Si l'envoi d'email échoue, on affiche quand même le succès de la création
        console.error('Erreur lors de l\'envoi de l\'email de confirmation:', emailError)
        await showAlert.success(
          'Compte créé avec succès ! L\'onboarding est terminé. (Note: L\'envoi de l\'email de confirmation a échoué)',
          'Inscription réussie'
        )
      }
    } else {
      // Afficher un popup de succès sans mention de l'email
      await showAlert.success(
        'Compte créé avec succès ! L\'onboarding est terminé.',
        'Inscription réussie'
      )
    }
    
    // Réinitialiser le formulaire et retourner à l'étape 1
    resetFlow()
  } catch (error: any) {
    const errorMsg = error.message || 'Une erreur est survenue lors de la création du compte.'
    errorMessage.value = errorMsg
    await showAlert.error(errorMsg, 'Erreur lors de la soumission')
  } finally {
    submitLoading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[18] || (_cache[18] = _createElementVNode("h2", { class: "secondary-font gap-4 mt-2 mb-6" }, "Onboarding - Création de compte", -1)),
    (pageLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[6] || (_cache[6] = [
          _createElementVNode("div", { class: "loader dark" }, null, -1)
        ]))]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (errorMessage.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(errorMessage.value), 1))
            : _createCommentVNode("", true),
          (successMessage.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(successMessage.value), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", {
                class: _normalizeClass(["stepper-step", { active: currentStep.value === 1, completed: currentStep.value > 1 }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (goToStep(1)))
              }, [
                _createElementVNode("div", _hoisted_8, [
                  (currentStep.value > 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, "✓"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_10, "1"))
                ]),
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "stepper-label" }, "Informations", -1))
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["stepper-line", { completed: currentStep.value > 1 }])
              }, null, 2),
              _createElementVNode("div", {
                class: _normalizeClass(["stepper-step", { active: currentStep.value === 2, completed: currentStep.value > 2 }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (currentStep.value > 1 ? goToStep(2) : null))
              }, [
                _createElementVNode("div", _hoisted_11, [
                  (currentStep.value > 2)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, "✓"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_13, "2"))
                ]),
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "stepper-label" }, "Pièces d'identité", -1))
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["stepper-line", { completed: currentStep.value > 2 }])
              }, null, 2),
              _createElementVNode("div", {
                class: _normalizeClass(["stepper-step", { active: currentStep.value === 3, completed: currentStep.value > 3 }]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (currentStep.value > 2 ? goToStep(3) : null))
              }, [
                _createElementVNode("div", _hoisted_14, [
                  (currentStep.value > 3)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, "✓"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_16, "3"))
                ]),
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "stepper-label" }, "Bulletins", -1))
              ], 2)
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_17, [
            _createVNode(OnboardingPersonalInfosForm, {
              collectivites: formParams.collectivites,
              "default-collectivite-id": defaultCollectiviteId.value,
              onSaved: onAccountCreated
            }, null, 8, ["collectivites", "default-collectivite-id"])
          ], 512), [
            [_vShow, currentStep.value === 1]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_18, [
            (formDatas.user)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createVNode(OnboardingIdentityDocumentsForm, {
                    user: {
              nom: formDatas.user.nom || '',
              prenom: formDatas.user.prenom || '',
              email: formDatas.user.email || '',
              telephone: formDatas.user.telephone || ''
            },
                    types_piece_identites: formParams.types_piece_identites,
                    onSaved: onIdentityDocumentsSaved
                  }, null, 8, ["user", "types_piece_identites"]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("button", {
                      class: "btn white2",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (goToStep(1)))
                    }, [...(_cache[10] || (_cache[10] = [
                      _createElementVNode("img", {
                        src: "/public/icons/icon-back.svg",
                        class: "btn-icon",
                        alt: ""
                      }, null, -1),
                      _createElementVNode("span", null, "Précédent", -1)
                    ]))])
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, currentStep.value === 2]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_21, [
            (formDatas.user)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    (formDatas.photo?.preview && typeof formDatas.photo.preview === 'string')
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: formDatas.photo.preview,
                          class: "rounded-100 overflow-hidden size-2xl",
                          alt: "Photo de profil"
                        }, null, 8, _hoisted_24))
                      : (_openBlock(), _createElementBlock("div", _hoisted_25, [...(_cache[11] || (_cache[11] = [
                          _createElementVNode("img", {
                            src: "/public/icons/icon-profil.svg",
                            width: "60%",
                            class: "opacity-50",
                            alt: ""
                          }, null, -1)
                        ]))])),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("h5", _hoisted_27, _toDisplayString(formDatas.user.prenom) + " " + _toDisplayString(formDatas.user.nom), 1),
                      _createElementVNode("span", _hoisted_28, _toDisplayString(formDatas.user.email) + " | " + _toDisplayString(getCollectiviteName(formDatas.user.collectivite_id)), 1)
                    ]),
                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "rounded-100 overflow-hidden size-2xl ml-auto" }, [
                      _createElementVNode("img", {
                        src: "/public/icons/icon-coop-finance.svg",
                        width: "100%",
                        alt: "Coop Finance"
                      })
                    ], -1))
                  ]),
                  _cache[17] || (_cache[17] = _createElementVNode("h2", { class: "font-semibold text-center my-6" }, "Charger vos 3 derniers bulletins de salaire", -1)),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("label", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          name: "send_kyc_email",
                          id: "send_kyc_email",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((sendKycEmail).value = $event))
                        }, null, 512), [
                          [_vModelCheckbox, sendKycEmail.value]
                        ]),
                        _cache[13] || (_cache[13] = _createElementVNode("span", { class: "slider round" }, null, -1))
                      ]),
                      _cache[14] || (_cache[14] = _createElementVNode("h6", { class: "label text-grey-600" }, "Envoyer l'email de confirmation KYC", -1))
                    ])
                  ]),
                  _createVNode(OnboardingPayslipDocumentsForm, {
                    "form-params": {
              user: {
                nom: formDatas.user.nom || '',
                prenom: formDatas.user.prenom || '',
                email: formDatas.user.email || '',
                telephone: formDatas.user.telephone || ''
              },
              photo: formDatas.photo
            },
                    loading: submitLoading.value,
                    onSaved: onPayslipDocumentsSaved
                  }, null, 8, ["form-params", "loading"]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("button", {
                      class: "btn white2",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (goToStep(2))),
                      disabled: submitLoading.value
                    }, [...(_cache[15] || (_cache[15] = [
                      _createElementVNode("img", {
                        src: "/public/icons/icon-back.svg",
                        class: "btn-icon",
                        alt: ""
                      }, null, -1),
                      _createElementVNode("span", null, "Précédent", -1)
                    ]))], 8, _hoisted_33),
                    _createElementVNode("button", {
                      class: "btn",
                      onClick: doSaveKYCDocuments,
                      disabled: submitLoading.value || !formDatas.bulletin1 || !formDatas.bulletin2 || !formDatas.bulletin3
                    }, [
                      _cache[16] || (_cache[16] = _createElementVNode("img", {
                        src: "/public/icons/icon-valider.svg",
                        class: "btn-icon",
                        alt: ""
                      }, null, -1)),
                      (!submitLoading.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_35, "Soumettre l'onboarding"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_36, "Soumission en cours..."))
                    ], 8, _hoisted_34)
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, currentStep.value === 3]
          ])
        ])),
    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "clear-both h-70" }, null, -1))
  ]))
}
}

})